const providerStore = () => {
    const providerMap = {};
    const set = (id, provider) => {
        providerMap[id] = provider;
        return provider;
    };
    const get = (id) => providerMap[id];
    const remove = (id) => {
        delete providerMap[id];
    };
    return {
        get,
        set,
        remove,
    };
};
export const ProviderStore = providerStore();
